/**
 * Scrolls an element vertically
 * @param element
 * @param globalBounds
 * @param scrollTo
 */
export function scrollVertical(element, globalBounds, scrollTo) {
  const scrollHeight = element.scrollHeight;
  if (scrollHeight <= element.offsetHeight) {
    return;
  }
  const bounds = element.getBoundingClientRect();
  const relativeTop = globalBounds.top - bounds.top;
  const relativeBottom = globalBounds.bottom - bounds.bottom;
  const padding = 1;
  if (relativeTop <= 0 && scrollTo !== 'next') {
    element.scrollTop = element.scrollTop + relativeTop - padding;
  } else if (relativeBottom > 0 && scrollTo !== 'back') {
    element.scrollTop = element.scrollTop + relativeBottom + padding;
  }
}

/**
 * Checks to see if the top of an `element` + 1
 * is closer to the top of the viewport than the top of a `container` element
 * @param container
 * @param element
 * @returns `true` or `false`
 */
export function elementTopIsClipped(container, element) {
  const cRect = container.getBoundingClientRect();
  const eRect = element.getBoundingClientRect();
  return eRect.top + 1 < cRect.top;
}

/**
 * Checks to see if the distance to the bottom of an `element` + 1
 * is farther from the top of the viewport than the bottom of a `container` element
 * @param container
 * @param element
 * @returns `true` or `false`
 */
export function elementBottomIsClipped(container, element) {
  const cRect = container.getBoundingClientRect();
  const eRect = element.getBoundingClientRect();
  return eRect.top + eRect.height - 1 > cRect.top + cRect.height;
}
//# sourceMappingURL=verticalScroll.js.map